// extracted by mini-css-extract-plugin
export default {"periodContainer":"periodContainer---vjOey","error":"error---IquZ9"};